<template>
  <CCard>
    <CCardHeader>اخبار</CCardHeader>
    <CCardBody >
      <CAlert
        v-if="newsList.length === 0 && !loading"
        color="info"
        class="w-100"
      >
        خبری ثبت نشده است.
      </CAlert>
      <CRow v-if="newsList.length && !loading">
        <CCol sm="4" v-for="(news, index) in newsList" :key="index">
          <NewsCard :news="news" />
        </CCol>
      </CRow>
    </CCardBody>
  </CCard>
</template>

<script>
import axios from "@/plugins/axios";
import NewsCard from "./NewsCard.vue";

export default {
  components: { NewsCard },
  data() {
    return {
      newsList: [],
      loading: true,
    };
  },
  beforeMount() {
    this.getNews();
  },
  methods: {
    async getNews() {
      try {
        this.loading = true;
        const payload = {
          page: 1,
        };
        const { data } = await axios.get("/news", {
          params: { ...payload },
        });
        this.newsList = data.objects.slice(0, 3);
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
